<div class="featured-products-container">
    <vs-carousel [carouselData]="carouselData" (buttonClicked)= "buttonClicked($event)"></vs-carousel>
</div>